module.exports = __webpack_public_path__ + "static/media/goodTemData.e8a39575.xls";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/excelTeml/goodTemData.xls
// module id = 5021
// module chunks = 0